module.exports = __webpack_public_path__ + "media/images/sports_icons/watersports-7e09a2897a72119bdf720adcce9d63bc.png";